import Vue from 'vue'
import './class-component-hooks'
import App from './App.vue'
import router from './router'
import store from './store'
import API from './api'
import VueKonva from 'vue-konva'
import PostMessage from './postMessage'
import ExternalApi from './external/api'
import './initDayjs'
import './init-audio'
import './init-device'
import { bleMockInit } from '@/ble/mock/bleMock.ts'
import { BleDeviceTypes } from './constants/ble'
import BleConnectionManager from '@/ble/connectionManager'
import { BleProviderEventTypes } from './ble/constants'

Vue.config.productionTip = false

Vue.use(API)
Vue.use(VueKonva)
Vue.use(PostMessage)
Vue.use(ExternalApi)

store.dispatch('user/refreshToken').finally(() => {
  if (process.env.NODE_ENV === 'development') {
    // store.dispatch('user/updateUserInfo').then(() => {
    //   console.log(store.state.user.info)
    //   if (store.state.user.info.isPatient) {
    //     bleMockInit([BleDeviceTypes.ECG_SERVICE])
    //     BleConnectionManager.provider.ble = (window as any).Ble
    //     BleConnectionManager.init()
    //     new Promise<string>(resolve => {
    //       BleConnectionManager.provider.startScan()
    //       const unsubscribe = BleConnectionManager.provider.addListener(
    //         BleProviderEventTypes.ADD_DEVICE,
    //         (_, address) => {
    //           const device = BleConnectionManager.provider.getDevice(address)
    //           if (device && device.deviceType === BleDeviceTypes.ECG_SERVICE) {
    //             unsubscribe()
    //             resolve(address)
    //           }
    //         }
    //       )
    //     })
    //       .then(targetAddress => {
    //         return BleConnectionManager.provider.connect(targetAddress)
    //       })
    //       .then(() => {
    //         ;(window as any).manager = BleConnectionManager
    //       })
    //   }
    // })
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
